var React = require('react');

function BackInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M12.5 7.93718L12.0629 7.5L7.50004 12.0631L7.50019 12.0633L7.5 12.0635L11.9997 16.5635L12.4368 16.1263L8.37385 12.0633L12.5 7.93718Z","fill":"currentColor","key":0}),React.createElement("circle",{"cx":"10","cy":"12","r":"9.75","stroke":"currentColor","strokeWidth":"0.5","key":1})]);
}

BackInline.defaultProps = {"viewBox":"0 0 24 24","fill":"none"};

module.exports = BackInline;

BackInline.default = BackInline;
